<i18n>
{
	"en": {
		"add": "Added",
		"remove": "Removed",
		"priceLines": "Pricelines",
		"chargeCode": "Code",
		"currency": "Currency",
		"amount": "Amount",
		"text": "Text"
	},
	"no": {
		"add": "Laget",
		"remove": "Slettet",
		"priceLines": "Prislinjer",
		"chargeCode": "Kode",
		"currency": "Valuta",
		"amount": "Beløp",
		"text": "Tekst"
	}
}
</i18n>
<template>
	<t-vertical-panel>
		<div slot="header" class="details-header">
			<t-panel-header
				:text="$t('priceLines')"
				icon="dollar"
				type="bp"
				size="md"
			/>
			<div class="details-header-sub-label" v-text="$t(op)"/>
			<t-icon-button
				style="margin-right: 10px;"
				appearance="minimal"
				type="bp"
				icon="cross"
				iconSize="md"
				@click="$emit('close')"
			/>
		</div>
		<div class="content">
			<t-pane v-bind="paneOptions">
				<div class="content-data">
					<TLabeledValue
						:label="$t('chargeCode')"
						:value="data.chargeCode"
						labelMarginBottom="5px"
					/>
					<TLabeledValue
						:label="$t('currency')"
						:value="data.currency"
						labelMarginBottom="5px"
					/>
					<TLabeledValue
						:label="$t('amount')"
						:value="data.amount"
						labelMarginBottom="5px"
					/>
					<TLabeledValue
						:label="$t('text')"
						:value="data.text"
						labelMarginBottom="5px"
					/>
				</div>
			</t-pane>
		</div>
	</t-vertical-panel>
</template>

<script>
export default {
	name: 'PriceLine',
	props: {
		data: Object,
		op: String
	},
	data() {
		return {
			paneOptions: {
				border: 'default',
				background: 'tint1',
				borderRadius: '5px',
				style: { padding: '5px', }
			},
		};
	}
};
</script>
<style lang="scss" scoped>
.content {
	margin: 10px;
}
.content-data {
	display: grid;
	grid-template-columns: minmax(150px, 1fr);
	column-gap: 20px;
	row-gap: 20px;
}
.details-header {
	height: 100%;
	display:flex;
	align-items: center;
	padding-left: 5px;
	.details-header-sub-label {
		flex: 1;
		color: #66788a;
		font-size: 14px;
	}
}
</style>